import { render, staticRenderFns } from "./SlideSidebarContainer.vue?vue&type=template&id=136316c1&scoped=true"
import script from "./SlideSidebarContainer.vue?vue&type=script&lang=js"
export * from "./SlideSidebarContainer.vue?vue&type=script&lang=js"
import style0 from "./SlideSidebarContainer.vue?vue&type=style&index=0&id=136316c1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "136316c1",
  null
  
)

export default component.exports